/* tslint:disable */
/* eslint-disable */
/**
 * PR TIMES Media List API
 * PR TIMESメディアリスト用 API
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import {
    GetAutoMediaListIdRelatedToPressReleaseResponseAllOf,
    GetAutoMediaListIdRelatedToPressReleaseResponseAllOfFromJSON,
    GetAutoMediaListIdRelatedToPressReleaseResponseAllOfFromJSONTyped,
    GetAutoMediaListIdRelatedToPressReleaseResponseAllOfToJSON,
} from './GetAutoMediaListIdRelatedToPressReleaseResponseAllOf';
import {
    MediaListApiResponse,
    MediaListApiResponseFromJSON,
    MediaListApiResponseFromJSONTyped,
    MediaListApiResponseToJSON,
} from './MediaListApiResponse';

/**
 * 
 * @export
 * @interface GetAutoMediaListIdRelatedToPressReleaseResponse
 */
export interface GetAutoMediaListIdRelatedToPressReleaseResponse {
    /**
     * ステータスコード
     * @type {number}
     * @memberof GetAutoMediaListIdRelatedToPressReleaseResponse
     */
    status: number;
    /**
     * ステータスメッセージ
     * @type {string}
     * @memberof GetAutoMediaListIdRelatedToPressReleaseResponse
     */
    message: string;
    /**
     * メディアリストIDリスト（自動選択リストの場合はプレスリリースと複数のメディアリストと紐づいている可能性があるため）
     * @type {Array<number>}
     * @memberof GetAutoMediaListIdRelatedToPressReleaseResponse
     */
    mediaListIds: Array<number>;
}

export function GetAutoMediaListIdRelatedToPressReleaseResponseFromJSON(json: any): GetAutoMediaListIdRelatedToPressReleaseResponse {
    return GetAutoMediaListIdRelatedToPressReleaseResponseFromJSONTyped(json, false);
}

export function GetAutoMediaListIdRelatedToPressReleaseResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): GetAutoMediaListIdRelatedToPressReleaseResponse {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'status': json['status'],
        'message': json['message'],
        'mediaListIds': json['media_list_ids'],
    };
}

export function GetAutoMediaListIdRelatedToPressReleaseResponseToJSON(value?: GetAutoMediaListIdRelatedToPressReleaseResponse | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'status': value.status,
        'message': value.message,
        'media_list_ids': value.mediaListIds,
    };
}

